import React from 'react';
import { Button } from '../ui/button';

const PWAInstallSection = ({ isAppInstallable, onInstall }) => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 mt-8" style={{ 
      background: 'linear-gradient(135deg, #C4A084 0%, #B89968 50%, #A88B5E 100%)'
    }}>
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-6">
          <span className="text-6xl">📱</span>
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Jetzt als App herunterladen!
        </h2>
        
        <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
          Installieren Sie unseren Shop als App auf Ihrem Handy, Tablet oder Computer. 
          Schneller Zugriff, keine Installation über den App Store nötig!
        </p>
        
        {/* Installation Instructions */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-[#F5E6D3]/90 backdrop-blur-sm rounded-lg p-6 hover:bg-[#F5E6D3] transition-all shadow-md">
            <div className="flex items-center justify-center mb-3">
              <div className="w-16 h-16 rounded-full bg-[#FAF0E6] flex items-center justify-center shadow-lg border-2 border-[#F5E6A0]">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#A7C7E7" className="w-8 h-8">
                  <path d="M10.5 18.75a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" />
                  <path fillRule="evenodd" d="M8.625.75A3.375 3.375 0 005.25 4.125v15.75a3.375 3.375 0 003.375 3.375h6.75a3.375 3.375 0 003.375-3.375V4.125A3.375 3.375 0 0015.375.75h-6.75zM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 017.5 19.875V4.125z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <h3 className="font-semibold text-[#6D5A47] mb-2">Auf dem Handy</h3>
            <p className="text-sm text-[#6B5744]">
              iOS: Teilen-Symbol → "Zum Home-Bildschirm"<br/>
              Android: Button unten klicken
            </p>
          </div>

          <div className="bg-[#F5E6D3]/90 backdrop-blur-sm rounded-lg p-6 hover:bg-[#F5E6D3] transition-all shadow-md">
            <div className="flex items-center justify-center mb-3">
              <div className="w-16 h-16 rounded-full bg-[#FAF0E6] flex items-center justify-center shadow-lg border-2 border-[#F5E6A0]">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#A8D5BA" className="w-8 h-8">
                  <path fillRule="evenodd" d="M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 01-.375.65 2.249 2.249 0 000 3.898.75.75 0 01.375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 17.625v-3.026a.75.75 0 01.374-.65 2.249 2.249 0 000-3.898.75.75 0 01-.374-.65V6.375zm15-1.125a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0V6a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0v.75a.75.75 0 001.5 0v-.75zm-.75 3a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zM6 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H6.75A.75.75 0 016 12zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <h3 className="font-semibold text-[#6D5A47] mb-2">Auf dem Tablet</h3>
            <p className="text-sm text-[#6B5744]">
              Wie auf dem Handy:<br/>
              Teilen → "Zum Home-Bildschirm"
            </p>
          </div>

          <div className="bg-[#F5E6D3]/90 backdrop-blur-sm rounded-lg p-6 hover:bg-[#F5E6D3] transition-all shadow-md">
            <div className="flex items-center justify-center mb-3">
              <div className="w-16 h-16 rounded-full bg-[#FAF0E6] flex items-center justify-center shadow-lg border-2 border-[#F5E6A0]">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#FFB6C1" className="w-8 h-8">
                  <path fillRule="evenodd" d="M2.25 5.25a3 3 0 013-3h13.5a3 3 0 013 3V15a3 3 0 01-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 01-.53 1.28h-9a.75.75 0 01-.53-1.28l.621-.622a2.25 2.25 0 00.659-1.59V18h-3a3 3 0 01-3-3V5.25zm1.5 0v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <h3 className="font-semibold text-[#6D5A47] mb-2">Am Computer</h3>
            <p className="text-sm text-[#6B5744]">
              Chrome: Installieren-Symbol in der Adressleiste<br/>
              Edge: App-Symbol neben der URL
            </p>
          </div>
        </div>

        {isAppInstallable && (
          <Button 
            onClick={onInstall}
            size="lg"
            className="bg-white text-[#8B7355] hover:bg-gray-100 font-semibold shadow-xl"
          >
            📲 Jetzt installieren
          </Button>
        )}
      </div>
    </section>
  );
};

export default PWAInstallSection;
